// Query keys for the Cohort entity — one source so invalidation stays in sync.

export const COHORT_KEYS = {
  all: ['cohort'] as const,
  managed: () => [...COHORT_KEYS.all, 'managed'] as const,
} as const;
